import React, { Component } from 'react';
import { Table, Modal, Button, Input, Radio, Select } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SearchRetrieve from '../../common/SearchRetrieve.new';

const RadioGroup = Radio.Group;

class ConfigColumn extends React.Component {
    state = {
        visible: false,
        percent: 30,
    }

    handleSubmit = () => {
        const { percent } = this.state;
        this.hide();
        this.props.setPercent(percent);
    }

    show = percent => {
        this.setState({
            percent,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    onChange = (e) => {
        this.setState({ percent: e.target.value });
    }

    render() {
        const { visible, percent } = this.state;
        const radioStyle = {
            display: 'inline-block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Modal
                title="百分比设置"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="condition-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
            >
                <div>
                    <label style={{ display: "inline-block", verticalAlign: "top", lineHeight: "30px" }}>随机百分比设置：</label>
                    <RadioGroup onChange={this.onChange} value={percent}>
                        <div>
                            <Radio style={radioStyle} value={10}>10%</Radio>
                            <Radio style={radioStyle} value={30}>30%</Radio>
                        </div>
                        <div>
                            <Radio style={radioStyle} value={50}>50%</Radio>
                            <Radio style={radioStyle} value={80}>80%</Radio>
                        </div>
                    </RadioGroup>
                </div>
            </Modal>
        );
    }
}

class Filter extends Component {
    state = {
        searchParams: {},
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    hospitalChange = ( options ) => {
        const { searchParams } = this.state;
        searchParams.hospitalMainId = options.value;
        searchParams.hospitalMainName = options.text;
        searchParams.hospitalId = undefined;
        this.setState({ searchParams },() => options.value && this.queryCourtyardAreaList());
    }

    courtyardAreaChange = (value) => {
        const { searchParams } = this.state;
        searchParams.hospitalId = value;
        this.setState({ searchParams });
    }

    timer = null;

    queryCourtyardAreaList = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { searchParams: { hospitalMainId } } = this.state;
            const options = {
                method: 'POST',
                url: API_URL.hospital.queryHospitalCourtyardAreaList,
                data: {    
                    hospitalMainId,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    const needCourtyardArea = datas && datas[0].courtyardArea;
                    this.setState({ CourtyardAreaList: datas, needCourtyardArea });
                }
            };
            $.sendRequest(options);
        }, 300);
    }

    setComaprePercent = () =>{
        this.props.changeShowConfig();
    }

    render() {
        const { searchParams, CourtyardAreaList, needCourtyardArea, } = this.state;
        const { cityName, hospitalMainName, hospitalMainId, departmentName, hospitalId } = searchParams;
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>)
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">城市</label>
                    <Input
                        value={cityName}
                        placeholder="请输入"
                        onChange={e => this.handleInputChange(e, 'cityName')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">医院名称</label>
                    <SearchRetrieve
                        keyword='hospitalName'
                        style={{ width: 200 }}
                        params={{ limit: 20 }}
                        placeholder="输入医院自动检索"
                        value={hospitalMainName}
                        url={API_URL.hospital.queryHospitalMainList}
                        config={{ id: 'hospitalMainId', name: 'hospitalMainName' }}
                        onChange={options => this.hospitalChange( options )}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">院区</label>
                        <Select
                            allowClear={true}
                            onSearch={this.queryCourtyardAreaList}
                            style={{ width: 180 }}
                            placeholder="请输入"
                            disabled={ !needCourtyardArea || !hospitalMainId } //本无院区，禁止填入；本有院区，且医院信息已填，允许填入
                            value={hospitalId}
                            onChange={value => this.courtyardAreaChange(value, 'hospitalId')}
                        >
                            {CourtyardAreaOptions}
                        </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">科室</label>
                    <Input
                        value={departmentName}
                        placeholder="请输入"
                        onChange={e => this.handleInputChange(e, 'departmentName')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.setComaprePercent}>百分比设置</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

class SiteCompare extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        data: [],
        pagination: {
            current: 1,
            pageSize: 8,
        },
        loading: false,
        visible: false,
        percent: 50,
    }

    show = () => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData();
        })
    }

    hide = () => {
        this.setState({
            visible: false,
            sortParams: {},
            searchParams: {},
            pagination: {
                current: 1,
                pageSize: 8,
            },
            percent: 50,
        })
    }

    loadData = () => {
        const { searchParams: searchParamsComment, percent: commentPercent } = this.props;
        const { percent, sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.commentInfo.querySiteCompare,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                ...searchParamsComment,
                percent,
                commentPercent,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            }, errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: { ...params },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { percent, sortParams, searchParams } = this.state;
        const { searchParams: searchParamsComment, percent: commentPercent } = this.props;
        const options = {
            ...searchParamsComment,
            ...searchParams,
            ...sortParams,
            percent,
            commentPercent,
        };
        ExportUtil.export(options, null, API_URL.export.exportSiteCompare);
    }

    getColumns = () => {
        const { percent } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 85,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 85,
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
        }, {
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
        }, {
            title: '参与项目数量',
            dataIndex: 'investigationAccount',
            key: 'investigationAccount',
            width: 110,
            sorter: true,
            sortType: 'COMMON',
        }, {
            title: '进行中项目数量',
            dataIndex: 'inHandInvestigationAccount',
            key: 'inHandInvestigationAccount',
            width: 85,
            sorter: true,
            sortType: 'COMMON',
        }];
        if (percent == 50) {
            columns.push({
                title: '随机排名前50%项目数量',
                dataIndex: 'fiftyPresentAccount',
                key: 'fiftyPresentAccount',
                width: 100,
                sorter: true,
                sortType: 'COMMON',
            }, {
                title: '随机排名前50%比率',
                dataIndex: 'fiftyPresent',
                key: 'fiftyPresent',
                width: 100,
                sorter: true,
                sortType: 'COMMON',
                render: (text, record) => {
                    return `${text}%`
                }
            });
        }
        if (percent == 10) {
            columns.push({
                title: '随机排名前10%项目数量',
                dataIndex: 'tenPresentAccount',
                key: 'tenPresentAccount',
                width: 100,
                sorter: true,
                sortType: 'COMMON',
            }, {
                title: '随机排名前10%比率',
                dataIndex: 'tenPresent',
                key: 'tenPresent',
                width: 100,
                sorter: true,
                sortType: 'COMMON',
                render: (text, record) => {
                    return `${text}%`
                }
            });
        }
        if (percent == 30) {
            columns.push({
                title: '随机排名前30%项目数量',
                dataIndex: 'thirtyPresentAccount',
                key: 'thirtyPresentAccount',
                width: 100,
                sorter: true,
                sortType: 'COMMON',
            }, {
                title: '随机排名前30%比率',
                dataIndex: 'thirtyPresent',
                key: 'thirtyPresent',
                width: 100,
                sorter: true,
                sortType: 'COMMON',
                render: (text, record) => {
                    return `${text}%`
                }
            });
        }
        if (percent == 80) {
            columns.push({
                title: '随机排名前80%项目数量',
                dataIndex: 'eightyPresentAccount',
                key: 'eightyPresentAccount',
                width: 100,
                sorter: true,
                sortType: 'COMMON',
            }, {
                title: '随机排名前80%比率',
                dataIndex: 'eightyPresent',
                key: 'eightyPresent',
                width: 100,
                sorter: true,
                sortType: 'COMMON',
                render: (text, record) => {
                    return `${text}%`
                }
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = (data || []).map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    configPercent = () => {
        const { percent } = this.state;
        this.configColumnRef.show(percent);
    }

    setPercent = (percent) => {
        this.setState({
            percent
        }, () => {
            this.loadData()
        })
    }

    render() {
        const { visible, loading, pagination, percent } = this.state;
        return (
            <Modal
                title="中心比较"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="1200px"
                maskClosable={false}
                footer={<Button type="ghost"onClick={this.hide}>关闭</Button>}
            >
                <div className="full home">
                    {
                        visible &&
                        <Filter
                            search={this.search}
                            export={this.export}
                            changeShowConfig={this.configPercent}
                        />
                    }
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.index}
                        loading={loading}
                        onChange={this.handleTableChange}
                        pagination={pagination}
                    />
                    <ConfigColumn
                        percent={percent}
                        setPercent={this.setPercent}
                        ref={el => this.configColumnRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

export default SiteCompare;




// WEBPACK FOOTER //
// ./src/components/siteComment/researchCenterRecommend/SiteCompare.js